module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "navigation"
    }
  }, [_c('div', {
    staticClass: "navigation__head"
  }, [_c('img', {
    staticClass: "navigation__logo",
    attrs: {
      "src": "/static/img/logo.svg"
    }
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "navigation__profile-image"
  }, [_c('span', {
    staticClass: "font-primary--bold"
  }, [_vm._v(_vm._s(_vm.userInitials))])]), _vm._v(" "), _c('p', {
    staticClass: "navigation__username"
  }, [_vm._v(_vm._s(_vm.user.fullName))]), _vm._v(" "), _c('p', {
    staticClass: "navigation__user-role"
  }, [_vm._v(_vm._s(_vm.userRole))])]), _vm._v(" "), _c('ul', {
    staticClass: "list-bare"
  }, [_c('li', [_c('router-link', {
    staticClass: "button font-secondary",
    attrs: {
      "to": '/' + _vm.homeRoute
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _vm._l((_vm.navItems[_vm.userGroup]), function(item) {
    return (item.route != '/account') ? _c('li', [_c('router-link', {
      staticClass: "button font-secondary",
      attrs: {
        "to": item.route
      }
    }, [_vm._v(_vm._s(item.name))])], 1) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.navItems[_vm.userGroup]), function(item) {
    return (item.route == '/account' && _vm.user.permissionsGroup == 'admin') ? _c('li', [_c('router-link', {
      staticClass: "button font-secondary",
      attrs: {
        "to": item.route
      }
    }, [_vm._v(_vm._s(item.name))])], 1) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "navigation__sub-menu"
  }, [_c('p', [_c('a', {
    on: {
      "click": function($event) {
        _vm.doLogout()
      }
    }
  }, [_vm._v("Logout")])])])], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3ea4123f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/Navigation/Navigation.vue
// module id = 542
// module chunks = 1